import translations from 'translations';
import messages from './messages';
import { IRouteBreadCrumb } from './type';
const routes: IRouteBreadCrumb[] = [
  {
    name: 'Market',
    nameLocal: translations(messages.market),
    path: '/market',
  },
  {
    name: 'BestDeals',
    nameLocal: translations(messages.bestDeals),
    path: '/market?tags=BEST_DEALS',
  },
  {
    name: 'NewProducts',
    nameLocal: translations(messages.newProducts),
    path: '/market?tags=NEW_PRODUCTS',
  },
  {
    name: 'BestPrices',
    nameLocal: translations(messages.bestPrices),
    path: '/market?tags=BEST_PRICES',
  },
  {
    name: 'Recommended',
    nameLocal: translations(messages.recommended),
    path: '/market?tags=RECOMMENDED_FOR_YOU',
  },
  {
    name: 'Combo',
    nameLocal: translations(messages.combo),
    path: '/market?tags=SUPER_COMBO',
  },
  {
    name: 'CpProducts',
    nameLocal: translations(messages.cpProducts),
    path: '/market?tags=CP_PRODUCTS',
  },
  {
    name: 'JpProducts',
    nameLocal: translations(messages.jpProducts),
    path: '/market?tags=JP_PRODUCTS',
  },
  {
    name: 'BookInAdvance',
    nameLocal: translations(messages.bookInAdvance),
    path: '/market?tags=BOOK_IN_ADVANCE',
  },
  {
    name: 'VinaMilkAndDalat',
    nameLocal: translations(messages.vinaMilkDalatMilk),
    path: '/market?tags=VINAMILK_DALAT_MILK',
  },
  {
    name: 'Torani',
    nameLocal: translations(messages.torani),
    path: '/market?tags=TORANI',
  },
  {
    name: 'VegetableSuperSaving',
    nameLocal: translations(messages.vegetableSuperSaving),
    path: '/market?tags=VEGETABLE_SUPER_SAVING',
  },
  {
    name: 'Fruits',
    nameLocal: translations(messages.fruits),
    path: '/market?tags=FRUITS',
  },
  {
    name: 'DishWashingLiquid',
    nameLocal: translations(messages.dishWashingLiquid),
    path: '/market?tags=DISHWASHING_LIQUID',
  },
  {
    name: 'Lettuce',
    nameLocal: translations(messages.lettuce),
    path: '/market?tags=LETTUCE',
  },
  {
    name: 'MeatZero',
    nameLocal: translations(messages.meatZero),
    path: '/market?tags=MEAT_ZERO',
  },
  {
    name: 'DalatCarrot',
    nameLocal: translations(messages.dalatCarrot),
    path: '/market?tags=DALAT_CARROT',
  },
  {
    name: 'FlashSales',
    nameLocal: translations(messages.flashSales),
    path: '/market?tags=FLASH_SALES',
  },
  {
    name: 'Favorite',
    nameLocal: translations(messages.favorite),
    path: '/favorite',
  },
  {
    name: 'FavoriteCombo',
    nameLocal: translations(messages.combo),
    path: '/favorite?tags=SUPER_COMBO',
    parentName: 'Favorite',
    type: 'favorite',
  },
  {
    name: 'Account',
    nameLocal: translations(messages.account),
    path: '/account-info',
  },
  {
    name: 'Company',
    nameLocal: translations(messages.companyInfo),
    path: '/company-info',
  },
  {
    name: 'Store',
    nameLocal: translations(messages.store),
    path: '/store-info',
  },
  {
    name: 'OverView',
    nameLocal: translations(messages.overview),
    path: '/overview',
  },
  {
    name: 'ItemAnalysis',
    nameLocal: translations(messages.analysis),
    path: '/item-analysis',
  },
  {
    name: 'Notifications',
    nameLocal: translations(messages.notifications),
    path: '/notifications',
  },
  {
    name: 'Cart',
    nameLocal: translations(messages.cart),
    path: '/checkout',
  },
  {
    name: 'Order',
    nameLocal: translations(messages.orderHistory),
    path: '/orders',
    childrenName: 'OrderDetail',
  },
  {
    name: 'OrderDetail',
    nameLocal: translations(messages.orderDetail),
    path: '',
  },
  {
    name: 'OrderPendingApproval',
    nameLocal: translations(messages.orderPendingApproval),
    path: '/orders-pending-approval?supplier=',
    childrenName: 'OrderPendingApprovalDetail',
  },
  {
    name: 'OrderPendingApprovalDetail',
    nameLocal: translations(messages.orderDetail),
    path: '',
  },
  {
    name: 'UserManagement',
    nameLocal: translations(messages.usersManagement),
    path: '/user-management',
  },
  {
    name: 'UserInformation',
    nameLocal: translations(messages.usersManagement),
    path: '/user-details',
    childrenName: 'UserDetail',
  },
  {
    name: 'UserDetail',
    nameLocal: translations(messages.userInformation),
    path: '',
  },
  {
    name: 'GroupManagement',
    nameLocal: translations(messages.groupsManagement),
    path: '/group-management',
  },
  {
    name: 'GroupInformation',
    nameLocal: translations(messages.groupsManagement),
    path: '/groups',
    childrenName: 'GroupDetail',
  },
  {
    name: 'GroupDetail',
    nameLocal: translations(messages.groupsInformation),
    path: '',
  },
];
export default routes;
